const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "BackupMonth",
		label: "备份年月",
		columnwidth: 100,
	},
	{
		prop: "ReportName",
		label: "报表名称",
		columnwidth: 260,
	},
	{
		prop: "FileUrl",
		label: "文件地址",
	},
	{
		prop: "Download",
		label: "操作",
		columnwidth: 150,
		fixed: "right",
	}
];
export default headerData